"use client"

import { ColumnDef } from "@tanstack/react-table"
import { MoreHorizontal, ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"

import { Checkbox } from "@/components/ui/checkbox"
import TecniciansRowActions from "./TechniciansRowActions"
import { format } from "date-fns"


export type Technicians = {
    id: string
    beacon_store_id: number
    name: string
    first_name: string
    last_name: string
    slug: string
    email: string
    telephone: string
    status: number
    email_verified_at: Date
    created_at: Date
    updated_at: Date
}

interface rowActionProps {
    onEdit: (data: any) => void;
    onDelete: (data: any) => void;
    onAddBeaconsToTechnicians: (value: any) => void;
    roles: string[]
}
export const techniciansColumns = ({ onEdit, onDelete, onAddBeaconsToTechnicians, roles }: rowActionProps): ColumnDef<Technicians>[] => {
    const columns: ColumnDef<Technicians>[] = [

        {
            accessorKey: "id",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Id
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
        },
        {
            accessorKey: "slug",
            header: "slug",
        },
        {
            accessorKey: "name",
            header: "Store",
        },
        {
            accessorKey: "first_name",
            header: "First Name",
        },
        {
            accessorKey: "last_name",
            header: "Last Name",
        },
        {
            accessorKey: "email",
            header: "Email",
        },
        {
            accessorKey: "telephone",
            header: "Telephone",
        },
        {
            accessorKey: "status",
            header: "Status",
            cell: ({ row }) => {
                const value: any = row.original
                const statusText = value.status === 1 ? "Active" : "Not Active"
                const bgColor = value.status === 1 ? "bg-green-500" : "bg-red-500"
                return (
                    <span className={`px-2  rounded-full ${bgColor} text-white`}>
                        {statusText}
                    </span>
                );
            },
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                       Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
    ]
    if (roles.includes('technician-edit') || roles.includes('technician-delete') || roles.includes('beacon-edit')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <TecniciansRowActions row={row} onEdit={onEdit} onDelete={onDelete} onAddBeaconsToTechnicians={onAddBeaconsToTechnicians} roles={roles} />,
        })
    }
    return columns
}
